import { Outlet, useMatches } from 'react-router-dom'
import { RouteTemplate, type RouteTemplateProps } from './RouteTemplate'

export type RouteFrame = Omit<RouteTemplateProps, 'children'>
export type RouteHandle = { frame: RouteFrame }

export function AuthenticatedFrame() {
  const matches = useMatches()
  const handle = matches.map(match => match.handle as RouteHandle | undefined).findLast(handle => handle?.frame)
  if (!handle) throw new Error('Authenticated routes require frame metadata')
  return <RouteTemplate {...handle.frame}><Outlet /></RouteTemplate>
}
